import { base, transports } from '@ourzora/chains'
import { createConfig } from '@privy-io/wagmi'

const getWagmiConfig = () => {
  return createConfig({
    chains: [base],
    transports: transports.REMOTE,
  })
}

export const WAGMI_CONFIG = getWagmiConfig()
